import { BRAND } from "constants/brand";
import { Ring } from "@uiball/loaders";
import "assets/styles/table.scss";
import { useDispatch, useSelector } from "react-redux";
import { useState, useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import DeleteItem from "components/Ui/DeleteItem/DeleteItem";
import Category from "./Category/Category";
import useOptions from "hooks/useOptions";
import { setPage } from "store/optionSlice";
import AddOptions from "./AddOptions/AddOptions";
import EditOptions from "./EditOptions/EditOptions";
import { Pagination, Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import SearchInput from "components/Ui/SearchInput/SearchInput";
import TableColumnsMenu from "components/Ui/TableColumnsMenu/TableColumnsMenu";
import TableHead from "components/Ui/TableHead/TableHead";
import useTableColumnsConfig from "hooks/useTableColumnsConfig";

const COLUMNS = [
    { id: "id", label: "#", width: "10px" },
    { id: "name", label: "الاسم", width: "100px" },
    { id: "actions", label: "الاعدادات", width: "50px" },
];

const Options = () => {
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const { loading, editOption, deleteOption, fetchOptions } = useOptions();
    // Show the full-page spinner only on the first load. On later refetches
    // (search/pagination) keep the list — and the search box — mounted so
    // typing doesn't unmount and refocus the input.
    const [hasLoaded, setHasLoaded] = useState(false);
    useEffect(() => {
        if (!loading) setHasLoaded(true);
    }, [loading]);
    const data = useSelector((state) => state.option.options);
    const pages = useSelector((state) => state.option.pages);
    const page = useSelector((state) => state.option.page);
    const toast = useRef(null);
    const dispatch = useDispatch();
    const { orderedColumns, visibleColumns, hiddenSet, toggleColumn, moveColumn, reset } =
        useTableColumnsConfig("options", COLUMNS);

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const newParams = {};
        newParams.page = page;
        newParams.size = 10;

        if (searchParams.get("search")) {
            newParams.search = searchParams.get("search");
        }

        fetchOptions(newParams);
    }, [page, searchParams]);

    const handleChangePage = (event, newPage) => {
        dispatch(setPage(newPage));
    };

    const showMessage = (type, head, content) => {
        toast.current.show({
            severity: type,
            summary: head,
            detail: content,
            life: 3000,
        });
    };

    const toggleAddForm = () => {
        setShowAddForm((pre) => (pre = !pre));
    };

    const toggleEditForm = () => {
        setShowEditForm((pre) => (pre = !pre));
    };

    const setSelectedCategoryValue = (category) => {
        setSelectedCategory(category);
    };

    const toggleDelete = () => {
        setShowDelete((pre) => (pre = !pre));
    };

    const confirmDelete = async () => {
        try {
            const response = await deleteOption(selectedCategory.id);
            // Assuming `response` contains information to check if the operation succeeded

            if (response) {
                showMessage("warn", "تم الحذف", "تم حذف الاضافه بنجاح");
                toggleDelete();
            } else {
                showMessage("error", "هناك خطأ", "حدث خطأ غير متوقع");
            }
        } catch (err) {
            console.error("Error adding vendor:", err);
            showMessage("error", "هناك خطأ", "حدث خطأ غير متوقع");
        }
    };

    const handleSearch = (value) => {
        if (value) {
            searchParams.set("search", value);
        } else {
            searchParams.delete("search");
        }
        setSearchParams(searchParams);
        dispatch(setPage(1));
    };
    return (
        <div className="items">
            <Toast style={{ direction: "rtl" }} ref={toast} position="top-left" />

            {loading && !hasLoaded ? (
                <div className="loadingSpinner">
                    <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                </div>
            ) : (
                <>
                    <div className="controls">
                        <SearchInput
                            initialValue={searchParams.get("search") || ""}
                            onSearch={handleSearch}
                            placeholder="بحث بالاسم أو رقم الإضافة"
                            minWidth={290}
                        />
                        <div>
                            <button className="button" onClick={toggleAddForm}>
                                إضافه
                            </button>
                        </div>
                        <div style={{ marginInlineStart: "auto" }}>
                            <TableColumnsMenu
                                orderedColumns={orderedColumns}
                                hiddenSet={hiddenSet}
                                toggleColumn={toggleColumn}
                                moveColumn={moveColumn}
                                reset={reset}
                            />
                        </div>
                    </div>
                    <div className="table-container">
                        <table>
                            <TableHead visibleColumns={visibleColumns} />
                            <tbody>
                                {data ? (
                                    data.map((category) => (
                                        <Category
                                            key={category.id}
                                            category={category}
                                            visibleColumns={visibleColumns}
                                            editCategory={editOption}
                                            selectedCategory={selectedCategory}
                                            toggleEditForm={toggleEditForm}
                                            setSelectedCategoryValue={setSelectedCategoryValue}
                                            toggleDelete={toggleDelete}
                                        />
                                    ))
                                ) : (
                                    <h4>لا يوجد اضافات!</h4>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <Stack spacing={1}>
                        <Pagination
                            count={pages}
                            defaultPage={page}
                            shape="rounded"
                            color={BRAND}
                            style={{ margin: "20px auto 0" }}
                            onChange={handleChangePage}
                        />
                    </Stack>
                    <AddOptions
                        show={showAddForm}
                        close={toggleAddForm}
                        showMessage={showMessage}
                    />
                    <EditOptions
                        show={showEditForm}
                        close={toggleEditForm}
                        showMessage={showMessage}
                        category={selectedCategory}
                    />
                    <DeleteItem
                        show={showDelete}
                        close={toggleDelete}
                        loading={loading}
                        confirm={confirmDelete}
                    />
                </>
            )}
        </div>
    );
};
export default Options;
